import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();

import './bootstrap';

import jq from 'jquery';
// Reuse the sync-loaded jQuery instance so plugins registered above share
// the same $ that inline blade scripts use.
const $ = window.jQuery ?? jq;
window.$ = window.jQuery = $;

// DataTables and buttons are loaded synchronously via chrome.blade.php vendor scripts.
// Use a dynamic import guarded by a DataTables check — this file crashes on pages
// that use a layout without vendor scripts (e.g. the auth/OTP pages).
if (window.jQuery?.fn?.dataTable) {
    import('./buttons.server-side.js');
}
import Cookies from 'js-cookie';
window.Cookies = Cookies;

import ClipboardJS from 'clipboard';
window.ClipboardJS = ClipboardJS;

import AutoNumeric from 'autonumeric/dist/autoNumeric.min.js';
window.AutoNumeric = AutoNumeric;

import bsCustomFileInput from 'bs-custom-file-input';
window.bsCustomFileInput = bsCustomFileInput;

import * as JsDiff from 'diff';
window.JsDiff = JsDiff;

// notify.js uses bare $ — dynamic import ensures it
// executes after window.$ is set above (static imports are always hoisted).
import('./notify');

const initializeTooltips = () => {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((element) => {
        window.bootstrap.Tooltip.getOrCreateInstance(element);
    });
};

const initializePopovers = () => {
    document.querySelectorAll('[data-bs-toggle="popover"]').forEach((element) => {
        window.bootstrap.Popover.getOrCreateInstance(element);
    });
};

$(document).ready(function () {
    $(document).on('wheel', 'input[type=number]', function () {
        $(this).blur();
    });

    const clipboardjsBtn = new ClipboardJS('.btn');
    clipboardjsBtn.on('success', function (e) {
        const trigger = e.trigger;
        const existingTooltip = window.bootstrap.Tooltip.getInstance(trigger);
        if (existingTooltip) {
            existingTooltip.dispose();
        }

        trigger.setAttribute('data-bs-title', 'Copied!');
        const tooltip = new window.bootstrap.Tooltip(trigger, { trigger: 'manual' });
        tooltip.show();

        setTimeout(function () {
            tooltip.dispose();
        }, 2500);
    });

    if ($('input.dollars').length > 0) {
        AutoNumeric.multiple('input.dollars', {
            unformatOnSubmit: true,
            modifyValueOnWheel: false,
            onInvalidPaste: 'ignore',
        });

        $('input.dollars').change(function (e) {
            $(e.target).closest('form').change();
        });
    }

    if (typeof $.fn.datepicker !== 'undefined') {
        $('.date-picker').datepicker({
            format: 'yyyy-mm-dd',
            todayBtn: 'linked',
            todayHighlight: true,
            autoclose: true,
        });

        $('.date-picker').parent().find('span.input-group-prepend').click(function (e) {
            const field = $(e.target).parents('.input-group').find('.date-picker');
            field.datepicker('show');
        });
    }

    initializeTooltips();
    initializePopovers();
    bsCustomFileInput.init();
});
